module.exports = __webpack_public_path__ + "static/media/grader.b2242eb2.jpg";